import { render, staticRenderFns } from "./BaseFrontOfficeExpansionPanels.vue?vue&type=template&id=34032e49"
import script from "./BaseFrontOfficeExpansionPanels.vue?vue&type=script&lang=js"
export * from "./BaseFrontOfficeExpansionPanels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VExpansionPanels})
